import React from 'react';
import { withTranslation } from 'react-i18next';
import { SETTINGS } from 'refactored/features/emergencies/constants';
import BodyColumn from 'refactored/features/emergencies/ui/columns/body-column';
import RegularText from 'refactored/features/emergencies/ui/texts/regular-text';
import styled from 'styled-components';

const CustomRegularText = styled(RegularText)`
  font-size: 14px;
  text-align: center;
  color: var(--grey700);
`;
const ServiceTypeColumn = ({ ticket, t }) => {
  return (
    <BodyColumn
      backgroundColor={'#FFFFFF'}
      width={SETTINGS.TICKETS_TABLE_COLUMN_SIZES_IN_PX.SERVICE}
    >
      <CustomRegularText>
        {ticket.order_data.service_type.vehicle_type
          ? t(
              `available_vehicle_types.${ticket.order_data.service_type.vehicle_type}`
            )
          : ''}
      </CustomRegularText>
    </BodyColumn>
  );
};
export default withTranslation('Emergencies')(ServiceTypeColumn);
